module.exports = __webpack_public_path__ + "img/3-LO7.da52e58.jpg";